import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Button
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ApiService from "../../Api/ApiController";
import Swal from "sweetalert2";
import Search from "../../components/Search";

const DeletedUserList = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({});
  const [page,setpage] = useState(1);
  const [search,setsearch] =useState('');
  const handlePageChange=(page)=>{
    setpage(page)
  }
  const getuserlist = () => {
    ApiService.deleteuserlist({page,search})
      .then((response) => {
        if (response.data.status === true) {
          setUsers(response.data.data.data);
          setPagination(response.data.data.paginator);
        } else {
          setUsers([]);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    getuserlist();
  }, [page,search]);

 
  const handleSearch = (searchValue)=>{
    setsearch(searchValue);
  }

  return (
    <Box sx={{ padding: "16px" }}>
      <Typography variant="h4" gutterBottom>
       Deleted User List
      </Typography>
           <Box>
           <Search onSearch={handleSearch} />
           </Box>
      {/* Add a responsive wrapper */}
      <Box
        sx={{
        
          borderRadius: 1,
          boxShadow: 1,
        }}
      >
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="responsive table">
            <TableHead>
              <TableRow>
                <TableCell>S.No.</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Mobile Number</TableCell>
                <TableCell>Delete reason</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user, index) => (
                <TableRow key={user._id}>
                 <TableCell data-label="ID">{index + 1}</TableCell>
<TableCell data-label="Name">{user.name || "--"}</TableCell>
<TableCell data-label="Mobile Number">{"+91" + user.mobile_number}</TableCell>
<TableCell data-label="Delete Reason">{user.delete_reason || "--"}</TableCell>


                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div className="pagination_latestTrend">
      {pagination.totalPages > 1 && (
                        <>
                         
                              <Button disabled={!pagination.hasPrevPage}  onClick={() => handlePageChange(page - 1)}><i className='bx bx-left-arrow-alt' ></i></Button>
                       
                            <span>Page {page} of {pagination.totalPages}</span>
                           
                              <Button  disabled={!pagination.hasNextPage}  onClick={() => handlePageChange(page + 1)}><i className='bx bx-right-arrow-alt'></i></Button>
                        
                        </>
                    )}
                    </div>
      </Box>
    </Box>
  );
};

export default DeletedUserList;
